(function (angular) {

    'use strict';

    angular.module('harriApp').controller('SomethingWentWrongModal', SomethingWentWrongModal);

    SomethingWentWrongModal.$inject = ['$scope', 'modalData'];

    function SomethingWentWrongModal($scope, modalData) {
        var self = this;
        self.brandId = modalData.brandId;

        self.refreshPage = function () {
            window.location = "/settings/communication_emails/brand/" + self.brandId;
        };
    }
})(angular);
